export default __webpack_public_path__ + "static/media/Chess_ndt45.d714eeb4.svg";